import subTask from '@/api/project-mgt/sub-task-profile'

import { baseState, baseMutations } from '@/store/mixins'

export const state = {
  ...baseState
}

export const getters = {}

export const mutations = {
  ...baseMutations
}

export const actions = {
  fetch(context, { id, params }) {
    return subTask.get(id, { params })
  },
  store(context, data) {
    return subTask.store(data)
  },
  update(context, { id, data }) {
    return subTask.update(id, data)
  },
  destroy(context, id) {
    return subTask.destroy(id)
  },
  report(context, { id, data }) {
    return subTask.report(id, data)
  },
  getReport(context, id) {
    return subTask.getReport(id)
  },
  subTaskByProject(context, { id, params }) {
    return subTask.subTaskByProject(id, { params })
  }
}
